<template>
  <v-card class="IMThemeGray rounded-xl rounded-tl-0 text-right">
    <v-card-title
      class="IMThemeOrange py-2 text-white rounded-xl rounded-tl-0 justify-content-center"
    >
      {{ id == -1 ? "إضافة" : "تعديل" }}
    </v-card-title>
    <v-form ref="schedForm" v-model="valid">
      <v-card-text>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-row>
                <v-col cols="12" class="py-0">
                  <label>الأيام</label>
                </v-col>
                <v-col cols="6">
                  <label for="fromDay">من</label>
                  <v-autocomplete
                    id="fromDay"
                    v-model="scheduleForm.fromDay"
                    dense
                    rounded
                    class="rounded-tl-0"
                    color="IMThemeGray"
                    item-color="IMThemeGray"
                    solo
                    :rules="fromDay"
                    :items="daysList"
                    item-text="name"
                    item-value="id"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.name"></v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <label for="toDay">إلى</label>
                  <v-autocomplete
                    id="toDay"
                    v-model="scheduleForm.toDay"
                    dense
                    rounded
                    :rules="toDay"
                    class="rounded-tl-0"
                    color="IMThemeGray"
                    item-color="IMThemeGray"
                    solo
                    :items="daysList"
                    item-text="name"
                    item-value="id"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.name"></v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="py-2">
                  <label class="m-0">الأوقات</label>
                </v-col>
                <v-col cols="6">
                  <label for="fromTime">من</label>
                  <v-menu
                    ref="timepickerMenu_1"
                    v-model="timepickerMenu_1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="scheduleForm.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="scheduleForm.open"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        id="fromTime"
                        solo
                        :rules="fromTime"
                        dense
                        rounded
                        class="rounded-tl-0"
                        color="IMThemeGray"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timepickerMenu_1"
                      v-model="scheduleForm.open"
                      full-width
                      locale="ar-sy"
                      color="IMThemeGray"
                      @click:minute="$refs.timepickerMenu_1.save(scheduleForm.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <label for="toTime">إلى</label>
                  <v-menu
                    ref="timepickerMenu_2"
                    v-model="timepickerMenu_2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="scheduleForm.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="scheduleForm.close"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        solo
                        dense
                        :rules="[(v) => !!v || 'يرجى اختيار وقت نهاية']"
                        id="toTime"
                        rounded
                        class="rounded-tl-0"
                        color="IMThemeGray"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timepickerMenu_2"
                      v-model="scheduleForm.close"
                      full-width
                      locale="ar-sy"
                      color="IMThemeGray"
                      :disabled="scheduleForm.open == null"
                      @click:minute="$refs.timepickerMenu_2.save(scheduleForm.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-row>
                <v-col cols="12">
                  <label for="exeptionDay">اليوم المستثنى</label>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    id="exeptionDay"
                    v-model="scheduleForm.exeptionDay"
                    dense
                    rounded
                    class="rounded-tl-0"
                    color="IMThemeGray"
                    clearable
                    item-color="IMThemeGray"
                    solo
                    :items="daysList"
                    item-text="name"
                    item-value="id"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.name"></v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <label class="m-0">أوقات اليوم المستثنى</label>
                </v-col>
                <v-col cols="6">
                  <label for="exeptionOpen">من</label>
                  <v-menu
                    ref="menu"
                    v-model="not_timepickerMenu_1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="scheduleForm.exeptionOpen"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        id="exeptionOpen"
                        v-model="scheduleForm.exeptionOpen"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => (!scheduleForm.exeptionDay) || (!!scheduleForm.exeptionDay && !!v) || 'يرجى اختيار وقت الاستثناء']"
                        clearable
                        readonly
                        solo
                        dense
                        rounded
                        class="rounded-tl-0"
                        color="IMThemeGray"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="not_timepickerMenu_1"
                      v-model="scheduleForm.exeptionOpen"
                      full-width
                      locale="ar-sy"
                      color="IMThemeGray"
                      @click:minute="
                        $refs.menu.save(scheduleForm.exeptionOpen)
                      "
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <label for="toTime">إلى</label>
                  <v-menu
                    ref="not_timepickerMenu_2"
                    v-model="not_timepickerMenu_2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="scheduleForm.exeptionClose"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="scheduleForm.exeptionClose"
                         :rules="[(v) => (!scheduleForm.exeptionDay) || (!!scheduleForm.exeptionDay && !!v) || 'يرجى اختيار وقت الاستثناء']"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        solo
                        dense
                        clearable
                        rounded
                        class="rounded-tl-0"
                        color="IMThemeGray"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="not_timepickerMenu_2"
                      v-model="scheduleForm.exeptionClose"
                      full-width
                      locale="ar-sy"
                      color="IMThemeGray"
                      @click:minute="
                        $refs.not_timepickerMenu_2.save(scheduleForm.exeptionClose)
                      "
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-btn
              @click="SubmitSetSchedule()"
              rounded
              class="rounded-tl-0 px-8"
              :disabled="!valid"
            >
              تم
            </v-btn>
          </div>
          <div class="pt-3 text-center" v-if="id != -1">
            <router-link to="-1">
              <v-btn outlined rounded color="white" class="rounded-tl-0 px-8">
                إلغاء التحديد
              </v-btn>
            </router-link>
          </div>
        </v-col>
      </v-card-text>
    </v-form>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    id: String,
  },
  data: () => ({
    valid: false,
    fromDay: [(v) => !!v || "يرجى اختيار يوم البداية"],
    toDay: [(v) => !!v || "يرجى اختيار يوم النهاية"],
    fromTime: [(v) => !!v || "يرجى اختيار وقت البداية"],
    timepickerMenu_1: false,
    not_timepickerMenu_1: false,
    timepickerMenu_2: false,
    not_timepickerMenu_2: false,
  }),
  mounted() {
    if (this.id != -1) {
      this.fetchScheduleForm(this.id);
    } else {
      this.$refs.schedForm.reset();
    }
  },
  computed: {
    ...mapGetters(["scheduleForm", "daysList"]),
  },
  methods: {
    ...mapActions(["fetchScheduleForm", "setSchedule"]),
    SubmitSetSchedule() {
      this.setSchedule(this.scheduleForm).then(() => {
        this.$emit("close");
      });
      this.$refs.schedForm.reset();
      if (this.id != -1) {
        this.$router.push("./-1");
      }
    },
  },
  watch: {
    id(newId) {
      if (this.id != -1) {
        this.fetchScheduleForm(this.id);
      } else {
        this.$refs.schedForm.reset();
      }
    },
  },
};
</script>
